import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4l12 0","key":"svg-0"}],["path",{"d":"M12 4l0 16","key":"svg-1"}]]

const IconLetterT = createReactComponent('outline', 'letter-t', 'LetterT', __iconNode);

export default IconLetterT;